import '../app/shared/sentry/init'

import { NavigationButtonTrigger } from '@finviz/knowledge-base/reader/NavigationButtonTrigger'
import { KnowledgeBaseWrapper } from '@finviz/knowledge-base/reader/context'
import * as React from 'react'
import * as ReactDOM from 'react-dom/client'
import { Outlet, createBrowserRouter } from 'react-router'

import '../../styles/charts.css'
import '../../styles/modal.css'
import '../../styles/tailwind.css'
import '../../styles/timeframe-bar.css'
import { RouterProviderDom } from './RouterProviderDom'
import { ScrollRestore } from './components/ScrollRestore'
import { RouterErrorElement } from './components/error-view'
import { NotificationWrapper } from './components/notification'
import { SettingsContext } from './context'
import { useTrackPageView } from './hooks/use-track-pageview'
import { alertsModule } from './modules/alerts'
import { calendarModule } from './modules/calendar'
import { insiderTradingModule } from './modules/insider-trading'
import { portfolioModule } from './modules/portfolio'
import { quoteModule } from './modules/quote'
import { lazyLoadComponent } from './util-routing'
import { defineLazyRoutes } from './util-routing'

const KnowledgeBaseDialog = lazyLoadComponent({
  chunkName: 'knowledge-base',
  load: () => import(/* webpackChunkName: "knowledge-base" */ '@finviz/knowledge-base/reader/Dialog'),
})

const router = createBrowserRouter([
  {
    path: '/',
    Component: () => {
      useTrackPageView()

      return (
        <SettingsContext.Provider value={FinvizSettings}>
          <NotificationWrapper>
            <Outlet />
            <ScrollRestore />
          </NotificationWrapper>
        </SettingsContext.Provider>
      )
    },
    ErrorBoundary: RouterErrorElement,
    children: defineLazyRoutes([
      ...alertsModule,
      ...calendarModule,
      ...insiderTradingModule,
      ...portfolioModule,
      ...quoteModule,
      {
        path: '/charts',
        LazyComponent: () => import(/* webpackChunkName: "charts" */ './modules/charts'),
      },
      {
        path: '/save_to_portfolio.ashx',
        LazyComponent: () => import(/* webpackChunkName: "save-to-portfolio" */ './modules/save-to-portfolio/Route'),
      },
      {
        path: '/create_alert.ashx',
        LazyComponent: () => import(/* webpackChunkName: "create-alert" */ './modules/create-alert/Route'),
      },
      {
        path: '/create_alert_portfolio.ashx',
        loaderBundle: () =>
          import(/* webpackChunkName: "create-alert-portfolio-loaders" */ './modules/create-alert-portfolio/loaders'),
        LazyComponent: () =>
          import(/* webpackChunkName: "create-alert-portfolio" */ './modules/create-alert-portfolio/Route'),
      },
    ]),
  },
])

const rootEl = document.getElementById('root')
const root = ReactDOM.createRoot(rootEl!)

root.render(
  <KnowledgeBaseWrapper>
    <RouterProviderDom router={router} />
    {FinvizSettings.hasKnowledgeBase && (
      <>
        <NavigationButtonTrigger />
        <React.Suspense fallback={null}>
          <KnowledgeBaseDialog />
        </React.Suspense>
      </>
    )}
  </KnowledgeBaseWrapper>
)
